module.exports = __webpack_public_path__ + "img/gb13806_1_c.prt.73ab67ab.jpg";